import { cn } from "@/lib/utils/cn";
import { forwardRef, type HTMLAttributes, type ReactNode } from "react";

interface SectionProps extends HTMLAttributes<HTMLElement> {
  /** Background tone. `base` is the page background, `elevated` is one step up. */
  tone?: "base" | "elevated";
  /** Adds a subtle 1px top border to visually separate from previous section. */
  divided?: boolean;
  children: ReactNode;
}

export const Section = forwardRef<HTMLElement, SectionProps>(function Section(
  { tone = "base", divided = false, className, children, ...rest },
  ref
) {
  return (
    <section
      ref={ref}
      {...rest}
      className={cn(
        "relative px-6 py-24 lg:px-12 lg:py-32",
        tone === "elevated" ? "bg-elevated" : "bg-base",
        divided && "border-t border-line",
        className
      )}
    >
      <div className="mx-auto max-w-7xl">{children}</div>
    </section>
  );
});
